<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="pb-0 pb-0">
            <v-col class="pb-0" cols="12" md="12">
              <el-text-field
                label="Įgaliojimo tipo pavadinimas (LT)"
                v-model="formData.title_lt"
                :readonly="modeReadonly"
                :maxlength="200"
                required
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <el-text-field
                label="Įgaliojimo tipo pavadinimas (EN)"
                v-model="formData.title_en"
                :readonly="modeReadonly"
                :maxlength="200"
                required
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="6" lg="3">
              <el-text-field
                label="Įgaliojimo tipo kodas"
                disabled
                v-model="code"
                :maxlength="20"
              />
            </v-col>

            <v-col class="pb-0" cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja nuo"
                required
                :readonly="modeReadonly"
                v-model="formData.valid_from"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja iki"
                :afterDate="formData.valid_from"
                v-model="formData.valid_to"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="6" lg="3">
              <el-autocomplete
                :items="enumsClassifiers.whoMayConsituteMandateType"
                :readonly="modeReadonly"
                required
                enums
                itemvalue="value"
                itemtext="text"
                label="Matomumas pagal roles"
                v-model="formData.visibility"
                :disabled="disableByActions"
              />
            </v-col>
            <!-- after selected -->
            <template v-if="showAfterSelected">
              <v-col class="pt-0" cols="12" md="12">
                <el-checkbox
                  class="mt-0"
                  label="Visos paslaugos ir veiksmai (visų institucijų)"
                  v-model="formData.all_services"
                  :readonly="modeReadonly"
                >
                </el-checkbox>
              </v-col>
              <v-col class="pt-0" cols="12" md="12">
                <v-divider></v-divider>
              </v-col>
              <!-- actions -->
              <template v-if="showActions">
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-autocomplete
                    :items="actionsList"
                    :readonly="modeReadonly"
                    itemvalue="value"
                    itemtext="text"
                    label="Paslaugos"
                    v-model="formData.service_id"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="6">
                  <el-button
                    v-if="!modeReadonly"
                    color="primary"
                    icon="pridėti"
                    title="Pridėti"
                    @click.native.stop="addNew()"
                    :loading="loading"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="12">
                  <v-data-table
                    class="mb-4 custom-table sticky-header"
                    :loading="loading"
                    :header-props="{
                      sortByText: $t('Rūšiuoti pagal'),
                    }"
                    :headers="headers"
                    :items="actions"
                    :hide-default-footer="true"
                    disable-pagination
                  >
                    <!-- custom templates -->
                    <template v-slot:item="{ item }">
                      <el-table-mandate-service-row
                        @deleteItem="deleteItem"
                        :level="1"
                        :item="item"
                        show
                      />
                    </template>
                  </v-data-table>
                </v-col>
              </template>
            </template>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
    <modal-delete
      title="Įrašo šalinimas"
      :text="`Ar tikrai norite pašalinti?`"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import Enums from '@/enums'
import ModalDelete from '@/components/modals/ModalDelete'

export default {
  name: 'AdminMandateTypeForm',
  components: {
    ModalDelete,
  },
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      code: '',
      formData: {},
      actionsList: {},
      servicesData: {},
      actions: [],
      classifiers: {},
      enumsClassifiers: {},
      showDelete: false,
      modalDeleteItem: null,
      newlyAddedData: [],
      originalVisibility: '',
    }
  },
  computed: {
    disableByActions() {
      return this.actions.length > 0
    },
    showAfterSelected() {
      return this.originalVisibility == this.formData.visibility
    },
    showActions() {
      return !this.formData.all_services
    },
    modeReadonly() {
      return false
    },
    getId() {
      return this.$route.params.id || null
    },
    getDublicate() {
      return this.$route.params.duplicate === 'dublicate' || null
    },
    getTitle() {
      if (this.getDublicate) {
        return this.$t(`Naujas įgaliojimo tipas kito tipo pagrindu`)
      } else if (this.getId) {
        return this.$t(`Redaguoti įgaliojimo tipą`)
      } else {
        return this.$t(`Naujas įgaliojimo tipas`)
      }
    },
    headers() {
      return [
        {
          text: '',
          align: 'right',
          sortable: false,
          value: '',
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('RC kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Institucija'),
          align: 'start',
          value: 'institucion',
        },
        {
          text: this.$t('PASIS kodas'),
          align: 'start',
          value: 'pasis_code',
        },
        {
          text: this.$t('Paslaugos pavadinimas (LT)'),
          align: 'start',
          value: 'title_lt',
        },
        {
          text: this.$t('Paslaugos pavadinimas (EN)'),
          align: 'start',
          value: 'title_en',
        },
      ]
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    } else {
      this.getClassifiers()
    }
  },
  methods: {
    setDeleteBtn(itemArray, old) {
      itemArray.map((item) => {
        this.$set(item, 'canDelete', true)
        if (!old) {
          this.$set(item, 'newlyAdded', true)
        }
        if (item.children.length > 0) {
          this.setDeleteBtn(item.children, old)
        }
      })
    },
    checkIfExist(itemsArray, service) {
      let logic = false
      for (let item of itemsArray) {
        if (
          item.children.length > 0 &&
          this.checkIfExist(item.children, service)
        ) {
          logic = true
          break
        }
        if (item.code == service.code) {
          logic = true
          break
        }
      }
      return logic
    },
    addNew() {
      let id = this.formData.service_id
      if (!id) {
        return this.$root.$emit('DATA_ERROR_CODE', '000016')
      }
      this.$axios
        .get(`actions/${id}/tree`)
        .then((res) => {
          let service = res.data.action
          if (this.checkIfExist(this.actions, service)) {
            this.$root.$emit('DATA_ERROR_CODE', '000017')
          } else {
            this.setDeleteBtn(service.children, false)
            service.newlyAdded = true
            service.canDelete = true
            this.actions.push(service)
            this.formData.service_id = ''
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    back() {
      this.$router.push({ name: 'classifierMandateTypes' })
    },
    async getClassifiers() {
      this.enumsClassifiers = Enums
      this.pageloading = true
      let requiredClassifiers = { classifiers: ['action'] }
      await this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveActions() {
      let formData = {}
      this.newlyAddedData = []
      this.returnSelected(this.actions)
      formData.services = this.newlyAddedData
      this.$axios
        .post(`mandate-types/${this.formData.id}/actions`, formData)
        .then(() => {
          if (this.getDublicate) {
            this.$router.push({
              name: 'adminMandateTypeForm',
              params: {
                id: this.formData.id,
              },
            })
            return this.getData()
          } else {
            this.showAfterSelected ? this.back() : this.getData()
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
    },
    getAvailableActions() {
      this.$axios
        .get(`mandate-types/${this.formData.id}/availableActions`)
        .then((res) => {
          this.actionsList = res.data
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
    },
    async getData() {
      this.pageloading = true
      await this.getClassifiers()
      this.$axios
        .get(`mandate-types/${this.getId}`)
        .then((res) => {
          this.formData = res.data.mandateType
          this.originalVisibility = this.formData.visibility
          this.code = this.formData.code
          if (this.getDublicate) {
            this.code = ''
          }
          this.actions = this.formData.services
          this.setDeleteBtn(this.actions, true)
          this.getAvailableActions()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    returnSelected(itemArray) {
      itemArray.map((item) => {
        this.returnSelected(item.children)
        this.newlyAddedData.push(item.id)
      })
    },
    saveData() {
      if (
        this.actions.length == 0 &&
        this.showAfterSelected &&
        !this.formData.all_services
      ) {
        return this.$root.$emit('DATA_ERROR_CODE', '000016')
      }
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          formData.code = this.code
          formData.all_services = this.formData?.all_services || false
          let url = `mandate-types`
          if (this.getId && !this.getDublicate) {
            formData.id = this.getId
          } else {
            formData.id = null
          }
          this.$axios
            .post(url, formData)
            .then((res) => {
              if(res.data.message){
                this.$root.$emit('DATA_INFO_TEXT', res.data.message)
              } else {
                this.$root.$emit('DATA_OK_CODE', '000110')
              }
              if (this.getId) {
                this.formData = res.data.mandateType
                this.saveActions()
              } else {
                this.$router.push({
                  name: 'adminMandateTypeForm',
                  params: {
                    id: res.data.mandateType.id,
                  },
                })
                this.getData()
              }
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    deleteItems(itemArray, id) {
      itemArray.map((item, index) => {
        if (item.id === id) {
          itemArray.splice(index, 1)
        }
        if (item.children.length > 0) {
          this.deleteItems(item.children, id)
        }
      })
    },
    confirmDelete(item) {
      this.deleteItems(this.actions, item.id)
      this.showDelete = false
    },
  },
}
</script>
<style lang="scss" scoped></style>
